import React from 'react';
import { shallowEqual } from 'react-redux';

import { t } from '~/helpers/localization';
import useVortexBattleTypes from '~/hooks/useVortexBattleTypes';
import { useAppSelector } from '~/store';

import styles from './CStarsTasks.scss';
import CStarsTasksCard from './CStarsTasksCard';

import type { RootState } from '~/store';

const stateSelector = (state: RootState) => {
  return {
    seasonQuests: state.ReducerClanStars.seasonQuests,
  };
};

const CStarsTasks: React.FC = () => {
  const { seasonQuests } = useAppSelector(stateSelector, shallowEqual);
  const { loaded } = useVortexBattleTypes();

  return (
    <div>
      <h2 className={styles.title}>{t('Выполняйте задачи')}</h2>
      <p className={styles.text}>
        {t(
          'Выполняйте задачи в составе отряда и зарабатывайте звёзды. За каждую выполненную задачу вы получите одну звезду.',
        )}
      </p>
      <section className={styles.cards}>
        {seasonQuests.map((quest) => {
          return <CStarsTasksCard task={quest} isBattleTypesLoading={!loaded} key={`quest_${quest.name}`} />;
        })}
      </section>
    </div>
  );
};

export default React.memo(CStarsTasks);
